import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo } from 'react';
import { RangeUnitFields } from 'console/tabs/maintenance/notification/range-unit-fields';
import { Alert, Box, FormControl, FormLabel, Tooltip } from '@mui/material';
import { useForm } from 'react-hook-form';
import { SettingCard, SettingFullRow, } from 'console/device-settings/z3k/components/material-utils/settings-card';
import { Save } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useMutationCallback } from 'console/shared/api/hooks';
import { isMediumUI } from 'console/shared/app/lib/choose-ui-type';
const defaultValues = {
    repeat: {
        date: null,
        mileage: null,
        moto_hours: null,
    },
    notify: {
        date: null,
        mileage: null,
        moto_hours: null,
    },
};
const form_control_sx = { gap: 1, flexDirection: 'row', width: '100%' };
export const PlannedNotification = memo(function PlannedNotification(props) {
    const { device_planned_notification, device_id } = props;
    const planned_notification = useMemo(() => device_planned_notification != null
        ? device_planned_notification
        : defaultValues, [device_planned_notification]);
    const { handleSubmit, control, formState: { isDirty }, setError, reset, } = useForm({
        defaultValues: planned_notification,
    });
    const [changePlannedNotification, loading, response, error] = useMutationCallback('edit_maintenance_planned_notification');
    useEffect(() => {
        if (error != null) {
            setError('root', { message: error });
        }
    }, [error]);
    const onApply = useCallback((data) => {
        changePlannedNotification({ planned_notification: data, device_id });
    }, [device_id]);
    useEffect(() => {
        if (response != null) {
            reset(response.planned_notification);
        }
    }, [response]);
    const container_props = useMemo(() => ({
        gridTemplateColumns: isMediumUI()
            ? '1fr'
            : 'repeat(auto-fill, minmax(250px, 1fr))',
    }), []);
    return (_jsx("form", { onSubmit: handleSubmit(onApply), children: _jsxs(SettingCard, { title: "\u041F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F", container_props: container_props, header_props: {
                action: (_jsx(Tooltip, { title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0435\u0440\u0438\u043E\u0434 \u0422\u041E", children: _jsx("span", { children: _jsx(LoadingButton, { loading: loading, color: "warning", type: "submit", disabled: !isDirty, children: _jsx(Save, {}) }) }) })),
            }, children: [error != null && _jsx(Alert, { severity: "error", children: error }), response != null && (_jsx(Alert, { severity: "success", children: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B" })), _jsx(SettingFullRow, { children: _jsxs(FormControl, { component: "fieldset", sx: form_control_sx, children: [_jsx(FormLabel, { component: "legend", children: "\u0420\u0430\u0437 \u0432 ..." }), _jsx(Box, { width: "100%", display: "grid", gap: 1, sx: {
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(275px, 1fr))',
                                }, children: _jsx(RangeUnitFields, { control: control, control_key: "repeat" }) })] }) }), _jsx(SettingFullRow, { children: _jsxs(FormControl, { component: "fieldset", sx: form_control_sx, children: [_jsx(FormLabel, { component: "legend", children: "\u041D\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u044C \u0437\u0430 ..." }), _jsx(Box, { width: "100%", display: "grid", gap: 1, sx: {
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(275px, 1fr))',
                                }, children: _jsx(RangeUnitFields, { control: control, control_key: "notify" }) })] }) })] }) }));
});
